import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-graphic-datapurchase',
  templateUrl: './graphic-datapurchase.component.html',
  styleUrls: ['./graphic-datapurchase.component.sass']
})
export class GraphicDatapurchaseComponent implements OnInit {
  @Input() indexI;
  public usage2: any;
  public info = [];
  public mixed = false;
  public selectBan;
  public daysForEndOfCycle;
  constructor(private global: GlobalService) { }

  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.daysForEndOfCycle=this.calculateDaysForEndOfCycle(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDaysLeftField);

    this.usage_info();
    this.loadCanvas();
  }
  check(value) {
    if (value == 'G') {
      this.mixed = true;
    }
  }
  usage_info() {
    let counter1 = 0;
    let iDLocal: number = 0;
    let counter2 = 0;
    let percentage: number = 0;
    let counterPad = 0;
    let usage = '{';
    usage += '"subscribers":';
    usage += '[';
    for (var i = 0; i < this.info.length; i++) {
      this.check(this.info[i].productTypeField);
      counter2 = 0;
      counterPad = 0;
      if (counter1 > 0) { usage += ','; }
      usage += '{';
      usage += '"subscriber":';
      usage += '[';
      this.info[i].usageInfoField.dataOffersField.map(function (offers) {
        if (counter2 > 0) { usage += ','; }
        usage += '{';
        usage += '"offerGroup":"' + offers.offerGroupField + '",';
        usage += '"DPlanName":"' + offers.displayNameField + '",';
        usage += '"Quota":"' + offers.quotaField + '",';
        usage += '"DLocalTop":"' + offers.quotaTextField + '",';
        usage += '"iDLocal":"' + offers.usedField + '",';
        usage += '"iDLocalText":"' + offers.usedTextField + '",';
        if (parseFloat(offers.quotaField) > 0) {
          if (offers.usedField === null) {
            iDLocal = 0;
          }
          else {
            iDLocal = offers.usedField;
          }
          percentage = (iDLocal * 100) / parseFloat(offers.quotaField);
          percentage = parseInt(percentage.toString());
        }
        usage += '"percentage":' + percentage + ',';
        if (offers.offerGroupField.search('BASE') > -1) {
          usage += '"type":"PL-ACT"';
        }
        else if (offers.offerGroupField.search("NT_ROAM_GRANEL") > -1) {
          usage += '"type":"DR"';
        }
        else {
          if (counterPad === 0) {
            usage += '"type":"PQ-AD"';
          }
          else {
            usage += '"type":""';
          }
          counterPad++;
        }
        usage += '}';
        counter2++;
      });
      usage += '],"countDR":' + counter2 + ',"countPQAD":' + counterPad + ',"productType":"' + this.info[i].productTypeField + '"';
      usage += '}';
      counter1++;
    }
    usage += ']';
    usage += '}';
    this.usage2 = JSON.parse(usage).subscribers;
  }
  calculateDaysForEndOfCycle(cycleDays) {
    //calculo de los dias restante para el fin del ciclo de facturacion
    var hoy = new Date();
    var mes = hoy.getMonth() + 1;
    var diasMes;
    switch (mes) {
       case 1:diasMes = 31;break;
       case 2:diasMes = 28;break;
       case 3:diasMes = 31;break;
       case 4:diasMes = 30;break;
       case 5:diasMes = 31;break;
       case 6:diasMes = 30;break;
       case 7:diasMes = 30;break;
       case 8:diasMes = 31;break;
       case 9:diasMes = 30;break;
       case 10:diasMes = 31;break;
       case 11:diasMes = 30;break;
       case 12:diasMes = 31;break;
    }
    var porcConsumido;

   if (parseInt(cycleDays) < 0) {
       porcConsumido = 0;
   }
   else {
       porcConsumido = Math.round((100 * parseInt(cycleDays)) / diasMes);
       porcConsumido=100-porcConsumido;
   }
   return porcConsumido;
  }
  loadCanvas() {
    let objHtml;
    for (let i = 0; i < this.usage2.length; i++) {
        objHtml = 'idCanvasPaq_' + i;
        this.global.pid2D(document.getElementById(objHtml), this.daysForEndOfCycle);

    }
  }
  ngAfterViewInit(): void {
    this.loadCanvas();
  }
}
